import * as React from "react";
import { A11y, Navigation, Pagination } from "swiper/modules";
import { Swiper, useSwiper } from "swiper/react";

import { MD_WIDTH } from "styles/theme/layout";

import RightArrow from "../../assets/right-arrow.inline.svg";
import {
  PaginationButton,
  SliderNavWrapper,
  SliderPagination,
  SliderWrapper,
} from "./Slider.styles";

type NavProps = {
  title?: string;
};

const SliderNav = ({ title }: NavProps) => {
  const swiper = useSwiper();

  return (
    <SliderNavWrapper className="flex items-center justify-between">
      {title ? <div>{title}</div> : <div />}
      <div>
        <PaginationButton onClick={() => swiper.slidePrev()}>
          <RightArrow style={{ transform: "rotate(180deg)" }} />
        </PaginationButton>
        <PaginationButton className="pl-1" onClick={() => swiper.slideNext()}>
          <RightArrow />
        </PaginationButton>
      </div>
    </SliderNavWrapper>
  );
};

type Props = {
  children?: React.ReactNode;
  title?: string;
  className?: string;
};

export const PeopleSlider = ({ children, className, title }: Props) => {
  return (
    <SliderWrapper className={className}>
      <Swiper
        slidesPerView={2}
        spaceBetween={20}
        pagination={{
          clickable: false,
          enabled: false,
        }}
        style={{ zIndex: 0 }}
        navigation
        modules={[Navigation, Pagination, A11y]}
        breakpoints={{
          [MD_WIDTH]: {
            slidesPerView: 4,
          },
        }}
      >
        <SliderPagination>
          <SliderNav title={title} />
        </SliderPagination>
        {children && <div>{children}</div>}
      </Swiper>
    </SliderWrapper>
  );
};
